import { gsap, ScrollTrigger } from "./globals.js";

document.addEventListener("DOMContentLoaded", () => {
	// SLIDER ANIMATION
	ScrollTrigger.addEventListener("refreshInit", () => {
	  ['.links-slider__slider', '.team-slider__slider', '.single-post__related__slider'].forEach(selector => {
	    const slider = document.querySelector(selector);
	    if (slider) {
	      gsap.fromTo(
	        `${selector} .swiper-wrapper`,
	        {
	          x: '30vw',   // Starting position (from)
	          y: '30vw',
	          opacity: 0
	        },
	        {
	          scrollTrigger: {
	            trigger: selector,
	            start: 'top bottom',
	            end: 'top center',
	            scrub: 2,
	            once: true
	          },
	          x: 0,   // End position (to)
	          y: 0,
	          opacity: 1,
	          ease: "linear"
	        }
	      );
	    }
	  });
	});
});
